<template>
  <button class="component-feature-card" @click="$emit('click')">
    <div class="d-flex gap-8 w-100">
      <div class="flex-fill">
        <h4 class="fs-14 mb-2 text-dark text-semibold">
          {{ title }}
        </h4>
        <span class="fs-12 text-dark-40">
          {{ subtitle }}
        </span>
      </div>

      <div class="icon-pill" v-if="fill" :class="[`bg-${color}`]">
        <i class="fs-24" :class="[icon]" />
      </div>

      <i class="fs-40" :class="[icon, `text-${color}`]" v-else />
    </div>
  </button>
</template>
<script>
export default {
  props: {
    title: String,
    subtitle: String,
    icon: String,
    color: String,
    warning: String,
    fill: Boolean
  }
};
</script>
<style lang="scss">
.component-feature-card {
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  display: flex;
  text-align: left;
  align-items: center;
  padding: 24px;
  border-radius: 16px;
  border: none;
  background: var(--bg-2);
  transition: background-color 0.2s;
  line-height: 1;
  &:hover {
    background-color: var(--bg-3);
  }
  h4 {
    line-height: 20px;
  }
  span {
    line-height: 16px;
  }
  .icon-pill {
    border-radius: 50%;
    padding: 8px;
    height: 40px;
    width: 40px;
    i {
      color: var(--dark);
    }
  }
}
</style>
